<template>
    <div>
        <div class="create-company-container w-100 mt-6 pb-5">
            <div class="create-company-header d-flex align-items-center justify-content-between">
                <span class="fs-14 pl-4 text-white">Consultant Information</span>
                <span class="pointer" @click="expandTabs">
                    <i class="text-white" :class="{'icon-chevron-double-up':consultant_expand, 'icon-chevron-double-down':!consultant_expand}" style="font-size: 20px;"></i>
                </span>
            </div>
            <div v-if="consultant_expand" class="px-6">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Personal Email ID<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="100" class="input-field" v-validate="'required|email'"
                                    v-model="consultant_info.personal_email_id" placeholder="Enter Personal Email ID"
                                    name="personal_email_id" />
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ consultant_info.personal_email_id.length }}/100</span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('personal_email_id')">
                                {{errors.first('personal_email_id')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Login Email ID<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <div class="position-relative w-100">
                                    <div class="d-flex align-items-center">
                                        <input type="text" maxlength="20" class="input-field" v-validate="{required: true,regex: /^[a-zA-Z0-9-_.]+$/}"
                                            v-model="consultant_info.login_email_id" placeholder="Enter Login Email ID"
                                            name="login_email_id" @change="checkEmail" />
                                    </div>
                                    <div class="text-right position-absolute" style="right: 0;">
                                        <span class="input-field-length">{{ consultant_info.login_email_id.length }}/20</span>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center mx-2">
                                    <span>@</span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <input type="text" maxlength="100" :disabled="true" :readonly="true" class="input-field"
                                        v-model="consultant_info.company_domain" placeholder="Enter"
                                    />
                                </div>
                            </div>
                            <span v-if="check_email.status_id == 0" class="invalid-feedback-form text-danger">
                                Login id already Exist
                            </span>
                            <span v-else class="invalid-feedback-form text-danger" v-show="errors.has('login_email_id')">
                                {{errors.first('login_email_id')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Consultant First Name<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="45" class="input-field" v-validate="'required'"
                                    v-model="consultant_info.consultant_first_name" placeholder="Enter Consultant First Name"
                                    name="first_name" />
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ consultant_info.consultant_first_name.length }}/45
                                </span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('first_name')">
                                {{errors.first('first_name')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Consultant Last Name<span class="pl-1 text-danger">*</span></span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" maxlength="45" class="input-field" v-validate="'required'"
                                    v-model="consultant_info.consultant_last_name" placeholder="Enter Consultant Last Name"
                                    name="last_name" />
                            </div>
                            <div class="text-right position-absolute" style="right: 0;">
                                <span
                                    class="input-field-length">{{ consultant_info.consultant_last_name.length }}/45
                                </span>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('last_name')">
                                {{errors.first('last_name')}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="row">
                            <div class="col-lg-7 col-md-7 col-sm-6">
                                <span class="input-label">Start Date</span>
                                <div class="d-flex align-items-center mt-2">
                                    <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                    v-model="consultant_info.start_date" value-type="format" 
                                    :not-before="new Date()"
                                    :clearable="false" 
                                    @change="checkstartTime()"
                                    :editable="false" style="padding-left: 0px !important;"
                                    lang="en" type="date" format="DD/MM/YYYY">
                                </date-picker>
                                    <!-- <i class="icon icon-tick-success icon-check-circle"></i> -->
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 pl-5">
                                <span class="input-label">Time</span>
                                <div class="d-flex align-items-center mt-2">
                                    <el-select @change="endTime()" :disabled="consultant_info.start_date == ''" v-model="consultant_info.start_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="Start Time">
                                        <el-option
                                            v-for="(item, index) in time_format"
                                            :key="index" 
                                            :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <!-- <date-picker :disabled="consultant_info.start_date == ''" v-model="consultant_info.start_time" style="padding-right: 3px !important;padding-left: 0px !important;" :minute-step="1" name="start_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                    <!-- <date-picker v-model="consultant_info.start_time" style="padding-right: 3px !important;padding-left: 0px !important;" name="start_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm A" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="row">
                            <div class="col-lg-7 col-md-7 col-sm-6">
                                <span class="input-label">End Date</span>
                                <div class="d-flex align-items-center mt-2">
                                    <!-- <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                        v-model="consultant_info.end_date" value-type="format" lang="en"
                                        :not-before="consultant_info.start_date ? consultant_info.start_date : new Date()"
                                        :clearable="false"
                                        :editable="false" style="padding-left: 0px !important;"
                                        type="date" format="DD/MM/YYYY">
                                    </date-picker> -->
                                    <date-picker class="profile-date-picker calendar-edit-per input-field pt-0 pb-0 pr-0" 
                                        v-model="consultant_info.end_date" value-type="format" lang="en"
                                        :not-before="new Date()"
                                        @change="checkEndTime()"
                                        :disabled="consultant_info.start_time == ''"
                                        :editable="true" style="padding-left: 0px !important;"
                                        type="date" format="DD/MM/YYYY">
                                    </date-picker>
                                    <!-- <i class="icon icon-tick-warning icon-check-circle"></i> -->
                                </div>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-6 pl-5">
                                <span class="input-label">Time</span>
                                <div class="d-flex align-items-center mt-2">
                                    <el-select :disabled="consultant_info.end_date == ''" v-if="consultant_info.start_date == consultant_info.end_date" v-model="consultant_info.end_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="End Time">
                                        <el-option
                                            v-for="(item, index) in time_formats" :disabled="consultant_info.start_time >= item"
                                            :key="index"
                                            :label="item" style="padding-bottom: 0px !important;"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select v-else :disabled="consultant_info.end_date == ''" v-model="consultant_info.end_time" class="input-field" style="border-color: #080808 !important;margin-top: 0px;padding-top: 8px !important;padding-bottom: 0px !important;padding-left: 0px !important;padding-right: 0px !important;" placeholder="End Time">
                                        <el-option
                                            v-for="(item, index) in time_formats"
                                            :key="index"
                                            :label="item" style="padding-bottom: 0px !important;"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <!-- <date-picker :disabled="consultant_info.start_date == ''" v-model="consultant_info.end_time" style="padding-right: 3px !important;padding-left: 0px !important;" :minute-step="1" name="end_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm"   type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                    <!-- <date-picker v-model="consultant_info.end_time" style="padding-right: 3px !important;padding-left: 0px !important;" name="end_time" class="profile-date-picker calendar-edit-per input-field calendar-down-arrow-grey" format="hh:mm A" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 mt-6">
                        <div class="w-100 position-relative">
                            <span class="input-label">Role</span>
                            <div class="d-flex align-items-center mt-2">
                                <input type="text" :readonly="true" :disabled="true" maxlength="100" class="input-field" v-validate="'required'"
                                    v-model="consultant_info.role" placeholder="Enter Role" style="text-transform: capitalize;"
                                    name="First-Name" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-10 mb-10">
                <div class="d-flex align-items-center justify-content-center">
                     <button class="btn btn-outline-secondary" :disabled="save_create_btn_hide" @click="cancel" style="width: 120px;border-radius: 5px;">Cancel</button>
                     <button class="btn btn-new-primary ml-5" :disabled="!consultant_expand || save_create_btn_hide" @click="nextPermissionProduct" style="width: 120px;border-radius: 5px;">Next
                        <hollow-dots-spinner v-if="save_create_btn_hide" style="position: absolute;width: 160px !important;margin: 0;top: 12px;left: -15px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
    import moment from 'moment';
    import axios from "axios";
    import { HollowDotsSpinner } from "epic-spinners";
    import consultant from '../mixins/consultant';
    import { SweetModal } from 'sweet-modal-vue';
    export default {
        mixins: [consultant],
        props: ['consultant_data', 'comp_data'],
        components: {
            SweetModal, HollowDotsSpinner
        },
        data() {
            return {
                time_formats: [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                time_format: [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                warning_msg: '',
                success_msg: '',
                consultant_info: {
                    personal_email_id: '',
                    login_email_id: '',
                    consultant_first_name:'',
                    consultant_last_name:'',
                    role: 'As Consultant',
                    company_domain: '',
                    start_date: '',
                    end_date: '',
                    start_time: '',
                    end_time: '',
                },
                consultant_expand: true,
                save_create_btn_hide:false,
                check_email: [],
                stringified_response: "",
            }
        },
        methods: {
            checkEndTime(){
                var curr_date = moment(new Date().toUTCString()).format("DD/MM/YYYY")
                this.time_formats = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                if(this.consultant_info.end_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.time_formats.indexOf(temp_start_time)
                    this.time_formats.splice(0,indx+1)
                }
            },
            endTime(){
                if(this.consultant_info.start_time >= this.consultant_info.end_time)
                {
                    this.consultant_info.end_time = '';
                }
            },
            checkstartTime(){
                var curr_date = moment(new Date().toUTCString()).format("DD/MM/YYYY")
                this.consultant_info.start_time = "";
                this.consultant_info.end_date = "";
                this.consultant_info.end_time = "";
                this.time_format = [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ]
                if(this.consultant_info.start_date == curr_date){
                    var temp_start_time = ""
                    var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                    if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                        temp_start_time = curr_time.slice(0,3) + '00'
                    } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                        temp_start_time = curr_time.slice(0,3) + '15'
                    } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                        temp_start_time = curr_time.slice(0,3) + '30'
                    } else if(parseInt(curr_time.substring(3)) >= 45){
                        temp_start_time = curr_time.slice(0,3) + '45'
                    }
                    let indx = this.time_format.indexOf(temp_start_time)
                    this.time_format.splice(0,indx+1)
                }
            },
            async checkEmail() {
                let params = {
                    "login_email": this.consultant_info.login_email_id+'@'+this.consultant_info.company_domain.replace(/.+\/\/|www.|\+/g, '')
                };
                this.check_email = await this.checkEmailExit(params);
            },
            expandTabs() {
                this.consultant_expand = !this.consultant_expand;
            },
            nextPermissionProduct() {
                this.save_create_btn_hide = true
                this.$validator.validateAll().then(result => {
                    if (result) {
                        localStorage.setItem("consultant_data", JSON.stringify(this.create_data));
                        this.$emit('switchWizard');
                    }
                })
                this.save_create_btn_hide = false
            },
            cancel() {
                this.$router.push('/consultants/listview/cmpid/'+this.$route.params.company_id);
            },
            async getCompData(company_id) {
                try {
                    let response = await this.getCompanyById(company_id);
                    this.consultant_info.company_domain = response.response.domain;
                }
                catch (err) {
                    // console.log(err);
                }
            },
        },
        mounted() {
            // this.checkEmail();
            if(this.$route.path.startsWith('/consultants/editconsultant/cmpid')) {
                this.consultant_info.personal_email_id = this.consultant_data.personal_email;
                this.consultant_info.login_email_id = this.consultant_data.login_email.split("@")[0];
                this.consultant_info.consultant_first_name = this.consultant_data.first_name;
                this.consultant_info.consultant_last_name = this.consultant_data.last_name;
                this.consultant_info.role = 'As Consultant';
                this.consultant_info.company_domain = this.consultant_data.login_email.split("@")[1];
                this.consultant_info.start_date =  this.consultant_data.start_date ? this.consultant_data.start_date.split("-")[2]+"/"+this.consultant_data.start_date.split("-")[1]+"/"+this.consultant_data.start_date.split("-")[0] : "";
                this.consultant_info.end_date = this.consultant_data.end_date ? this.consultant_data.end_date.split("-")[2]+"/"+this.consultant_data.end_date.split("-")[1]+"/"+this.consultant_data.end_date.split("-")[0] : "";
                this.consultant_info.start_time = this.consultant_data.start_time ? this.consultant_data.start_time.split(":")[0]+':'+this.consultant_data.start_time.split(":")[1] : "";
                this.consultant_info.end_time = this.consultant_data.end_time ? this.consultant_data.end_time.split(":")[0]+':'+this.consultant_data.end_time.split(":")[1] : "";
                this.stringified_response = JSON.stringify(this.create_data)
            } else {
                this.getCompData(this.$route.params.company_id);
            }
        },
        computed: {
            fields_not_changed(){
                return this.stringified_response == JSON.stringify(this.create_data)
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            create_data() {
                return {
                    personal_email: this.consultant_info.personal_email_id,
                    login_email: this.consultant_info.login_email_id+'@'+this.consultant_info.company_domain.replace(/.+\/\/|www.|\+/g, ''),
                    first_name: this.consultant_info.consultant_first_name,
                    last_name: this.consultant_info.consultant_last_name,
                    start_date: this.consultant_info.start_date ? this.consultant_info.start_date.split('/')[2]+'-'+this.consultant_info.start_date.split('/')[1]+'-'+this.consultant_info.start_date.split('/')[0] : '',
                    start_time: this.consultant_info.start_time,
                    end_date: this.consultant_info.end_date ? this.consultant_info.end_date.split('/')[2]+'-'+this.consultant_info.end_date.split('/')[1]+'-'+this.consultant_info.end_date.split('/')[0] : '',
                    end_time: this.consultant_info.end_time,
                    company_id: this.$route.params.company_id,
                    role: 'consultant',
                    products: []
                }
            }
        },
        created() {
            const dict = {
                custom: {
                    first_name: {
                        required: () => "First Name is required",
                        regex: () => "Enter a Valid Name",
                    },
                    last_name: {
                        required: () => "Last Name is required",
                        regex: () => "Enter a Valid Name",
                    },
                    personal_email_id: {
                        required: () => "Personal Email is required",
                        email: () => "Enter a Valid Email",
                    },
                    login_email_id:{
                        required: () => "Login E-mail id is required",
                        regex: () => "Please enter valid Email Address",
                    },
                }
            };
            this.$validator.localize("en", dict);       
        },
    }
</script>

<style scoped>
    .btn-outline-secondary {
        color: #e82828;
        border: 1px solid #e82828 !important;
    }
    .btn-outline-secondary:hover {
        color: #fff;
        background-color: #e82828;
        border-color: #e82828 !important;
    }
    .icon-tick-warning{
        color: #ff9a06
    }
    .icon-tick-success{
        color: #008a63;
    }
    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
    }

    .create-company-container:first-child {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
    }

    .create-company-container:nth-child(2) {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
    }

    .create-company-container:last-child {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }

    .overflow-auto {
        overflow: auto;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .input-field {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100%;
        height: 40px;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .btn-new-cancel {
        color: #fff;
        background-color: #d51650;
        border-radius: 5px;
        padding-left: 35px;
        padding-right: 35px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #d51650;
        line-height: 30px;
        box-shadow: none;
    }
    .profile-date-picker {
        padding: 5px 10px !important;
    }
    .btn-new-primary:disabled{
        cursor: no-drop !important;
    }
    .btn:disabled{
        pointer-events: auto !important
    }
</style>